import { sagaEffects } from '../../dependencies';

import { saga as messages } from '../../modules/messages';

const { all } = sagaEffects;

export default function* () {
    yield all([messages()]);
}
